<au-expansion-panel [expanded]="true">
	<ng-container panel-title>
		<div class="files-text-header">
			<span>{{ 'files' | translate }}</span>
			@if (!hideCounter) {
				<div class="files-counter">
					<ongoing-counter [filesList]="filesList()"></ongoing-counter>
				</div>
			}
		</div>
	</ng-container>

	<ng-container panel-description>
		@if (restrictFileSourceMenu) {
			<button
				(click)="addButtonClickHandler($event, fileInput); $event.stopPropagation()"
				class="au-add-fab-button"
			>
				<mat-icon class="accent-icon" svgIcon="add"></mat-icon>
			</button>
		}

		@if (!restrictFileSourceMenu) {
			<button
				(click)="$event.stopPropagation()"
				[matMenuTriggerFor]="entityMenu"
				class="au-add-fab-button"
			>
				<mat-icon class="accent-icon" svgIcon="add"></mat-icon>
			</button>
		}
	</ng-container>

	<ng-container panel-content>
		<div class="content-wrapper">
			@if (filesList()?.length || totalRelatesFiles > 0) {
				<div class="filter-control">
					<cmms-applied-filters-bar [activePage]="filePage" />
					@if (selectedFilters().length) {
						<div class="d-flex space">
							@for (filter of selectedFilters(); track filter.initialIndex) {
								<applied-filter-button [filter]="filter" />
							}
						</div>
					}
				</div>
			}

			@if (!filesList().length) {
				<div class="file-loader-wrapper">
					<div
						(dragenter)="onDragFileEnter($event)"
						(dragleave)="onDragFileLeave($event)"
						(dragover)="onDragOver($event)"
						(drop)="handleImageDrop($event)"
						(click)="fileInput.click()"
						[class.dragover]="fileCouldBeDropped"
						class="empty-state-placeholder"
						[matTooltip]="
							'allowed_formats' | translate: { formats: niceFormattedFileTypes }
						"
						[matTooltipDisabled]="showFileTypesHint"
					>
						<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
						<p>{{ 'drag_drop_files' | translate }}</p>
						@if (showFileTypesHint) {
							<p class="text-center">
								{{ 'allowed_formats' | translate: { formats: niceFormattedFileTypes } }}
							</p>
						}
					</div>
				</div>
			}

			@if (filesList().length) {
				<div
					class="list-of-files m-t-xs"
					[class.file-list-scroll]="enableFileListScroll"
					(dragenter)="onDragFileEnter($event)"
					(dragover)="onDragOver($event)"
					[class.dragover]="fileCouldBeDropped"
				>
					<div
						class="dragover-layer"
						(drop)="handleImageDrop($event)"
						(dragleave)="onDragFileLeave($event)"
					>
						<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
						<p>{{ 'drag_drop_files' | translate }}</p>
					</div>
				</div>
			}

			@if (filteredFileList.length) {
				<div
					class="list-of-files"
					[class.file-list-scroll]="enableFileListScroll"
					(dragenter)="onDragFileEnter($event)"
					(dragover)="onDragOver($event)"
					[class.dragover]="fileCouldBeDropped"
				>
					<file-cards-list
						[selection]="selection"
						[title]="uploadTitle"
						[filesData]="filteredFileList"
						(openFile)="openFile($event)"
						(deleteFile)="deleteItemFromFileList($event)"
					/>
					<div
						class="dragover-layer"
						(drop)="handleImageDrop($event)"
						(dragleave)="onDragFileLeave($event)"
					>
						<mat-icon class="illustration" svgIcon="file-document"></mat-icon>
						<p>{{ 'drag_drop_files' | translate }}</p>
					</div>
				</div>
			}

			@if (showRelatedFiles) {
				<div class="related-files-container">
					@if (!relatedFilesLoading()) {
						@if (relatedFiles?.length) {
							<file-cards-list
								[selection]="selection"
								[filesData]="relatedFiles"
								[allowDelete]="false"
								[title]="'related' | translate"
								(openFile)="openFile($event, true)"
								(deleteFile)="deleteItemFromFileList($event)"
							/>
						}
					} @else {
						<div class="spinner-wrapper">
							<mat-spinner diameter="60"></mat-spinner>
						</div>
					}
					@if (relatedFiles?.length) {
						<au-paginator
							pagination
							[initialPageSize]="pageSize()"
							[nodes]="paginationData"
							(paginationEmit)="paginationUpdateHandler($event)"
						/>
					}
				</div>
			}

			@if (selection.selected.length) {
				<div class="toolbar-wrapper">
					<files-toolbar
						class="toolbar"
						[useSelectionService]="false"
						[selections]="selection.selected.length"
						[delegateClear]="true"
						[relatedFilesSelected]="relatedFileSelected"
						[loadedSelection]="loadedFilesSelected"
						(linkToEntityPressed)="notifyAssetForLink()"
						(deletePressed)="deleteMultipleItemsFromFileList()"
						(clearPressed)="clearSelectionPressed()"
					></files-toolbar>
				</div>
			}
		</div>

		<!-- $event.target['value']=null
    we need to nulled value inside the input to allow
    loading of the same file more then 1 time -->
		<input
			#fileInput
			type="file"
			[multiple]="!options?.restrictMultipleFilesLoading"
			(click)="$event.target['value'] = null"
			(change)="onFileChanged($event)"
			hidden
		/>
	</ng-container>
</au-expansion-panel>

<mat-menu
	#entityMenu="matMenu"
	class="au-select-actions"
	[xPosition]="'after'"
	[yPosition]="'below'"
>
	<button mat-menu-item class="accent-button" (click)="addExistingHandler($event)">
		<mat-icon class="secondary-text-icon" svgIcon="files"></mat-icon>
		<span>{{ 'existing_file' | translate }}</span>
	</button>

	<button
		mat-menu-item
		class="accent-button"
		(click)="addButtonClickHandler($event, fileInput)"
	>
		<mat-icon class="secondary-text-icon" svgIcon="add"></mat-icon>
		<span>{{ 'new_file' | translate }}</span>
	</button>
</mat-menu>
